import styled from 'styled-components';

import { PcFormInput } from '@main/pc-core-components';
import { sp } from '@main/theme';

export const FormItemTitleWrapper = styled.p`
  font-size: ${sp(1.75)};
  font-weight: 700;
  line-height: ${sp(1.75)};
`;

/*
 * Wrapper for the form input
 */
export const StyledFormInput = styled(PcFormInput)`
  order: initial;
  radius: ${sp(0.8)};
  min-width: 200px;
`;
